import axios from "axios";
import getAuthToken from './AuthService';
import * as cryptoJS from 'crypto-js';

interface Member {
    id: number,
    lastname: string,
    firstname: string,
    email: string,
    gender: string,
    birthYear: number,
    jobPosition: any,
    domain: any,
    identity: any,
    thematics: any,
    introduction: string,
    address: string,
    postalCode: string,
    city: string,
    department: string,
    region?: string,
    country?: string,
    qpv: string,
    location?: any,
    phoneNumber: string,
    noContact: any,
}

const MemberAll = (): Promise<Member[]> => {
    return new Promise((resolve, reject) => {
        const token = getAuthToken();
        if(token){
            axios.get(`${process.env.GATSBY_API_URL}/api/member/all`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                withCredentials: true
            })
            .then(response => {
                const decryptedData = cryptoJS.AES.decrypt(response.data, `${process.env.GATSBY_CRYPTO_KEY}--${token}`);
                resolve(JSON.parse(decryptedData.toString(cryptoJS.enc.Utf8)));
            }, error => {
                reject(error);
            });
        }else{
            reject('No valid token');
        }
    });
}

const MemberProfile = (slug:string): Promise<Member> => {
    return new Promise((resolve, reject) => {
        const token = getAuthToken();
        if(token){
            axios.get(`${process.env.GATSBY_API_URL}/api/member/${slug}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                withCredentials: true
            })
            .then(response => {
                const decryptedData = cryptoJS.AES.decrypt(response.data, `${process.env.GATSBY_CRYPTO_KEY}--${token}`);
                resolve(JSON.parse(decryptedData.toString(cryptoJS.enc.Utf8)));
            }, error => {
                reject(error);
            });
        }else{
            reject('No valid token');
        }
    });
}

const MemberLast = (): Promise<Member[]> => {
    return new Promise((resolve, reject) => {
        const token = getAuthToken();
        if(token){
            axios.get(`${process.env.GATSBY_API_URL}/api/member/last`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                withCredentials: true
            })
            .then(response => {
                const decryptedData = cryptoJS.AES.decrypt(response.data, `${process.env.GATSBY_CRYPTO_KEY}--${token}`);
                resolve(JSON.parse(decryptedData.toString(cryptoJS.enc.Utf8)));
            }, error => {
                reject(error);
            });
        }else{
            reject('No valid token');
        }
    });
}

const Report = (slug: string, message: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const token = getAuthToken();
        if(token){
            axios.post(`${process.env.GATSBY_API_URL}/api/member/report/${slug}`,
            {
                message: message
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                withCredentials: true
            })
            .then(response => {
                resolve(response.data);
            }, error => {
                reject(error);
            });
        }else{
            reject('No valid token');
        }
    });
}

const MemberRegistration = (data: any): Promise<boolean> => {

    const formatedData = JSON.parse(JSON.stringify(data));

    if(-1 !== formatedData.noContact.indexOf('autre :')){
        formatedData.noContact[data.noContact.indexOf('autre :')] = formatedData.noContactOther;
        delete formatedData.noContactOther;
    }
    delete formatedData.valid;
    delete formatedData.rulesAge;

    formatedData.phoneNumber.value.substring(0, 1)
    formatedData.phoneNumber = (`+${formatedData.phoneNumber.options.dialCode}${formatedData.phoneNumber.value}`).trim();

    formatedData.noContact = formatedData.noContact.join(', ');
    formatedData.qpv = formatedData.qpv.value;

    formatedData.domain = formatedData.domain.map((d:any) => d.name).join(', ');

    return new Promise((resolve, reject) => {
            axios.post(`${process.env.GATSBY_API_URL}/api/member`, formatedData,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true
            })
            .then(response => {
                resolve(('ok' === response.data.status));
            }, error => {
                reject(error);
            });
    });
}


export { MemberAll, MemberLast, Member, MemberProfile, Report, MemberRegistration }